// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mb-0 {
  margin-bottom: 0px;
}
/*# sourceMappingURL=booking-detail.component.css.map */`, "",{"version":3,"sources":["webpack://./booking-detail.component.less","webpack://./src/app/components/booking-detail/booking-detail.component.less"],"names":[],"mappings":"AAEA;EACE,kBAAA;ACDF;AACA,uDAAuD","sourcesContent":["@import (reference) \"../../../assets/less/colors.less\";\n\n.mb-0 {\n  margin-bottom: 0px;\n}\n\n",".mb-0 {\n  margin-bottom: 0px;\n}\n/*# sourceMappingURL=booking-detail.component.css.map */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
